<template>
  <div>
    <div v-if="$route.path.indexOf('_operation') === -1">
      <SpFinder
        ref="finder"
        row-key="id"
        :split-count="10"
        :url="table_url"
        :setting="setting"
        fixed-row-action
        reserve-selection
        :hooks="{
          beforeSearch
        }"
      >
      </SpFinder>
    </div>
    <router-view></router-view>

    <!-- 物流信息弹窗 -->
    <el-dialog
      title="填写物流信息"
      :visible.sync="logisticsDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="logisticsFormRef"
        :model="logisticsForm"
        :rules="logisticsRules"
        label-width="100px"
      >
        <el-form-item label="物流公司" prop="logistics_company">
          <el-select
            v-model="logisticsForm.logistics_company"
            placeholder="请选择物流公司"
            style="width: 100%"
          >
            <el-option
              v-for="item in logisticsCompanyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" prop="logistics_number">
          <el-input
            v-model="logisticsForm.logistics_number"
            placeholder="请输入物流单号"
            clearable
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCancelLogistics">取消</el-button>
          <el-button type="primary" @click="handleSubmitLogistics">提交</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { tableSetting } from './config'
import { tableUrl, exportWinningRecord, getLogisticsList, lotteryCnyWinningExpress } from './api'
import ImportDialog from '@/components/importDialog'

export default {
  components: {
    ImportDialog
  },
  data () {
    return {
      table_url: tableUrl,
      params: {},
      logisticsDialogVisible: false,
      logisticsForm: {
        logistics_company: '',
        logistics_number: ''
      },
      logisticsRules: {
        logistics_company: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        logistics_number: [
          { required: true, message: '请输入物流单号', trigger: 'blur' }
        ]
      },
      logisticsCompanyList: [],
      currentRow: null
    }
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  mounted() {
    this.logisticsList()
  },
  methods: {
    refresh() {
      this.$refs.finder.refresh()
    },
    handleClickTab() {
      this.refresh()
    },
    beforeSearch(params) {
      let newParams = {
        ...params,
        is_export: 0,
        pullTime: undefined,
        lottery_time_start: params.pullTime && params.pullTime[0],
        lottery_time_end: params.pullTime && params.pullTime[1]
      }
      this.params = newParams
      return newParams
    },
    // 导出中奖记录
    handleExport() {
      exportWinningRecord({...this.params, is_export: 1}).then(response => {
        if (response.data.data.success) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
        }
      })
    },
    // 填写物流
    handleFillLogistics(row) {
      console.log("🚢 ~ 当前打印的内容 ~ row:", row);

      this.currentRow = row
      this.logisticsForm = {
        logistics_company: '',
        logistics_number: ''
      }
      this.logisticsDialogVisible = true
      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.logisticsFormRef) {
          this.$refs.logisticsFormRef.clearValidate()
        }
      })
    },
    // 取消物流填写
    handleCancelLogistics() {
      this.logisticsDialogVisible = false
      this.currentRow = null
    },
    // 提交物流信息
    handleSubmitLogistics() {
      this.$refs.logisticsFormRef.validate((valid) => {
        if (valid) {
          // 提交物流信息的API调用
          lotteryCnyWinningExpress({
            id: this.currentRow.id,
            express_company: this.logisticsForm.logistics_company,
            express_tracking_number: this.logisticsForm.logistics_number
          }).then(response => {
            if (response.data.data) {
              this.$message({
                type: 'success',
                message: '物流信息提交成功'
              })

              this.logisticsDialogVisible = false
              this.currentRow = null
              this.refresh()
            }
          }).catch(error => {
            this.$message({
              type: 'error',
              message: error.message || '物流信息提交失败'
            })
          })
        } else {
          return false
        }
      })
    },
    // 获取可用物流公司
    logisticsList() {
      getLogisticsList().then(response => {
        console.log("🚢 ~ 当前打印的内容 ~ response:", response);
        const list = response.data.data.list.map(item => ({
          label: item.name,
          // value: item.value
          value: item.name
        }))
        this.logisticsCompanyList = list
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .search-field-value {
  width: auto !important;
}
::v-deep .sp-finder .cell .sp-finder-actions__wrap {
  justify-content: center !important;
}
</style>

<style lang="scss">
.el-tooltip__popper {
  max-width: 80%;
}
</style>
